import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

/**
 * StandardBackButton — desktop-only back arrow.
 *
 * Locked 2026-06-01 (per owner directive after the Q&I desktop screenshot
 * showed redundant "← Dashboard" + "← Back" pills):
 *   • Match the provider signup form arrow style exactly — 48x48 white
 *     square with a bold blue ChevronLeft.
 *   • NO "Back" label — arrow only.
 *   • Desktop only (`hidden sm:flex`); mobile uses the footer nav for
 *     home/back, so this button hides there.
 *
 * Behavior unchanged: tap → custom onClick, else fallbackPath, else
 * navigate(-1).
 */
const StandardBackButton = ({ onClick, fallbackPath }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (fallbackPath) {
      navigate(fallbackPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Back"
      data-testid="desktop-back-btn"
      className="hidden sm:flex h-12 w-12 rounded-md items-center justify-center shrink-0 hover:scale-105 transition-transform focus:outline-none focus:ring-2 focus:ring-blue-500"
      style={{ backgroundColor: '#FFFFFF', border: '1px solid #E2E8F0', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)' }}
    >
      <ChevronLeft className="w-5 h-5" style={{ color: '#2563EB' }} strokeWidth={3} />
    </button>
  );
};

export default StandardBackButton;
